import { render, staticRenderFns } from "./preview_modal_mobex_health_plus.vue?vue&type=template&id=463af7bd&scoped=true"
import script from "./preview_modal_mobex_health_plus.vue?vue&type=script&lang=js"
export * from "./preview_modal_mobex_health_plus.vue?vue&type=script&lang=js"
import style0 from "./preview_modal_mobex_health_plus.vue?vue&type=style&index=0&id=463af7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463af7bd",
  null
  
)

export default component.exports